import { COMPANY } from "./company";

/**
 * The six questions that decide it.
 *
 * Every answer here is checkable against something else in the repo — the
 * trial length comes from COMPANY, the GST position from the pricing module's
 * own note, the staff permissions from what the Staff screen actually grants.
 * A marketing FAQ that answers more generously than the product behaves is a
 * support ticket with a delay on it.
 *
 * Lives here rather than in Faq.jsx because the page is not its only reader:
 * seo.js builds the FAQPage JSON-LD and llms.txt from this same array, so
 * what a search engine or an answer engine quotes is what the page says.
 */
export const FAQ = [
  {
    q: "Do I need a computer to run this?",
    a: "No. Everything works from the phone in your pocket: adding members, taking payments, checking people in. If you do have a computer at the front desk, open the web app in its browser and you get the same gym laid out for a bigger screen. Nothing to install either way.",
  },
  {
    q: "What happens to the members I already have?",
    a: "Add them as you go, or add them in a sitting. A member takes three steps (name, dates and fee, first payment). The dates start today, and you can set them to the day they really joined. A plan is optional: pick one to fill in the dates and fee, or type your own. Most clubs put their active members in over the first week and let the lapsed ones arrive as they come back.",
  },
  {
    q: "Is there an iPhone app?",
    a: "Yes. Varzish Mate is on the App Store for iPhone: install it, sign in with a code sent to your WhatsApp number or your email address, and start the free trial. It is the same app as on Android, with push alerts. If you would rather not install anything, app.varzishmate.com works in Safari too.",
  },
  {
    q: "Do my members have to pay for anything?",
    a: "No. Only the gym pays, and there is no per-member charge. Your members never pay us anything.",
  },
  {
    q: "How do members check in, and do they need an app?",
    a: "Print the QR poster from the app and put it by the door. A member scans it with their phone camera, types their phone number and is marked in, with no app to install and no password. They also see how many days are left if their plan ends within a week. You or a trainer can still tap a name on the list for anyone without a phone. It marks attendance and does not open or lock a door.",
  },
  {
    q: "Can I give a trainer access without showing them the money?",
    a: "Yes, and that is the default. A trainer gets members, workouts and check-in. Revenue, expenses, pricing and the ledger stay with the owner.",
  },
  {
    q: "How do the payment reminders actually go out?",
    a: "For each reminder type (seven days before expiry, on the day, and 3, 7 and 14 days overdue) you choose Ask me, Auto or Off. Ask me is the default: the app drafts the message and opens your own WhatsApp, and you read it and tap send. Auto sends it for you from the Varzish Mate business WhatsApp number, within your plan's monthly credits, once your club subscribes. If Auto cannot send a reminder, it waits on your list to send by hand.",
  },
  {
    q: "Can I give members a workout plan?",
    a: "Yes. Build a workout template day by day, with sets, reps, weight, rest, tempo and notes, using the exercise library plus any exercises you add. Assign it to a member, change it later, or assign it to several members at once. You can share the routine as a PDF.",
  },
  {
    q: "Can I send one message to many members?",
    a: "Yes. Select the members on the Members screen and write one message. The app opens your own WhatsApp for each member, one after another, and you tap send. Bulk messaging is for the owner; trainers do not have it.",
  },
  {
    q: "Can members get their receipt and workout as a PDF?",
    a: "Yes. The app makes a PDF for a payment receipt, a member statement or a workout routine on your device. On the phone you share it from the share sheet, for example on WhatsApp. On the web console it downloads. The receipt is a payment receipt, not a GST invoice.",
  },
  {
    q: "What if I stop paying?",
    a: `Your data stays yours. You can export members and the full payment ledger to CSV at any time, including during the ${COMPANY.trialDays}-day trial and after a subscription lapses. Prices shown are before GST: checkout adds 18% GST, and the pay step shows the exact total before you pay.`,
  },
];
